module.exports = __webpack_public_path__ + "assets/icons/ic_location_on-043a.svg";